import { ItemType } from "antd/lib/menu/hooks/useItems";

export const menuReducer = {
    mode:"horizontal" ,
    defaultSelectedKeys:['Garantizados'],
    items:[{
        nombre: "Comprar",
        Key: "Comprar",
        icon: null,
        url:"/comprar"
    },
    {
        nombre: "Vender",
        Key: "Vender",
        icon: null,
        url:"/ventas"
    },
    {
        nombre: "Financiamiento",
        Key: "Financiamiento",
        icon: null,
        url:"/financiamiento"
    },
    {
        nombre: "Locales",
        Key: "Locales",
        icon: null,
        url:"/locales"
    },
    {
        nombre: "Blog",
        Key: "Blog",
        icon: null,
        url:"/blog"
    },
    {
        nombre: " Iniciar Sesion",
        key:" Iniciar Sesion",
        icon:null,
        url:"/login"
        
    }]
}


export const obtieneMenuItem  = (
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: ItemType[],
    type?: 'group',): ItemType  =>{ 
        return {
            key,
            icon,
            children,
            label,
            type,
        } as unknown as ItemType;
  }